import { ElementType, FC } from 'react';
import { Location } from 'react-router';
import { RoundedPaper } from '../../../../atomic';
import { PageMenuElementList } from './list';

export type MenuConfig = Array<MenuElement>;

export type MenuElement = {
  title: string;
  isActive?: (location: Location) => boolean;
  /**
   * Property link has precedence over onClick.
   */
  link?: string;
  /**
   * Property onClick will be ignored if link is set.
   */
  onClick?: () => void;
  config?: MenuConfig;
  isBaseLevel?: boolean;
  icon?: ElementType;
  secondaryIcon?: ElementType;
  disabled?: boolean;
  hidden?: boolean;
  tooltip?: string;
  /**
   * Action on this entry sits with the company. Rolls up to the parent, so a
   * collapsed submenu still shows that something below it needs attention.
   */
  hasTodo?: boolean;
};

type Props = {
  config: MenuConfig;
};

export const PageMenu: FC<Props> = ({ config }) => {
  return (
    <RoundedPaper
      id="page-sub-menu"
      sx={{
        paddingY: '1.375rem',
        overflowY: 'overlay',
        '& > *:last-child': {
          marginBottom: '0'
        }
      }}
    >
      <PageMenuElementList
        elements={config
          .filter((c) => !c.hidden)
          .map((c) => {
            return { ...c, isBaseLevel: true };
          })}
      />
    </RoundedPaper>
  );
};
